import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ee5ec86c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ec86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee5ec86c')) {
      api.createRecord('ee5ec86c', component.options)
    } else {
      api.reload('ee5ec86c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ee5ec86c&scoped=true", function () {
      api.rerender('ee5ec86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/welfareCard/index.vue"
export default component.exports